import axios from 'axios';

const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL;
const baseUrlFlow = process.env.REACT_APP_AWS_API_GATEWAY_URL_EXECUTE_FLOW;

export const fetchServiceJson = (work_flow, accessToken, idCompany='') => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "company_action_selection_select",
            'action': "SELECT_ID",
            'variables': JSON.stringify({ 'work_flow': work_flow, 'id_company': idCompany })
        })
    });
};

export const fetchProducts = (accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            "process": "electronic_documents_details_select",
            "action": "SELECT_ALL", 
            "variables": `{}`
        })
    });
};

export const fetchActionsSelect = (field, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "company_action_selection_select",
            'action': "SELECT_BY_FIELD",
            'variables': JSON.stringify({ 'field': field })
        })
    });
};

export const fetchAttachment = (obj, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "attachment_select",
            'action': "SELECT_BY_ID_UNIQUE",
            'variables': JSON.stringify(obj)
        })
    });
};
export const getClientAsociated = (obj, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "contact_select", 
            'action': "SELECT_CLIENTS_ASSOCIATED",
            'variables': JSON.stringify(obj)
        })
    });
};

export const deleteAttachment = (obj, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrlFlow,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(obj)
    });
};

export const getCompanies = (id_user_action, accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'company_select',
            'action': 'SELECT_COMPANIES',
            'variables': JSON.stringify({ 'id_user_action': id_user_action })
        })
    })
}
export const fecthResolutions = (nit, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "resolution_select",
            'action': "SUPPLIER_ID",
            'variables': JSON.stringify({supplier_id: nit})
        })
    });
};

export const getAssociatedDocument = (document_id, id_company_supplier,  accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "electronic_documents_select", 
            'action': "SELECT_DOCUMENT_ASSOCIATED",
            'variables': JSON.stringify({document_id, id_company_supplier})
        })
    });
};

export const getAccessScreen = (work_flow, id_company,  accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "user_access_select", 
            'action': "SELECT_ACCESS",
            'variables': JSON.stringify({id_company, work_flow})
        })
    });
};